import { IAdFoxBannerContext } from '@cian/adfox';
import * as React from 'react';

import { trackAdFoxMortgage } from '../../../../tracking/ad-fox-mortgage';
import { IOfferCardImageBannerStateProps } from './offer-card-image-banner-container';

const styles = require('./offer-card-image-banner-style.css');

export interface IOfferCardImageOwnBannerProps {
  context: IAdFoxBannerContext;
}

export interface IOfferCardImageBannerProps extends IOfferCardImageOwnBannerProps, IOfferCardImageBannerStateProps {}

export class OfferCardImageBanner extends React.Component<IOfferCardImageBannerProps> {
  public componentDidMount(): void {
    const {
      context: { bannerId },
      tracking: { user, page },
    } = this.props;

    trackAdFoxMortgage('show', 'BannerIpoteka', bannerId, user, page);
  }

  public render() {
    return (
      <div
        onClick={this.clickHandler}
        style={{ backgroundImage: `url(${this.props.context.backgroundImage})` }}
        className={styles['mortgage-offer-card-banner-wrapper']}
      />
    );
  }

  private clickHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();

    const {
      context: { bannerId },
      tracking: { user, page },
    } = this.props;

    trackAdFoxMortgage('click', 'BannerIpoteka', bannerId, user, page);

    window.open(this.props.context.reference);
  };
}
